<script>
export default {
	name: 'LeafletLayer',
	inject: ['state'],
	props: { layer: { type: Object, required: true }, },
	data() {
		return { rendered: false };
	},
	computed: {
		map() {
			return this.state.map;
		}
	},
	watch: {
		layer: {
			immediate: true,
			handler() {
				if (this.map) this.rendered = false;
			}
		}
	},
	render() {
		if (this.map && !this.rendered) {
			this.map.hasLayer(this.layer) && this.map.removeLayer(this.layer);
			this.map.addLayer(this.layer);
			this.map.invalidateSize();
			this.rendered = true;
			this.$emit('layer', this.layer);
		}
		return null;
	}
};
</script>
